import { render, staticRenderFns } from "./SacConfig.vue?vue&type=template&id=c3874ab8"
import script from "./SacConfig.vue?vue&type=script&lang=js"
export * from "./SacConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports